






















































































import 'reflect-metadata'
import { Component, Vue, Prop } from 'vue-property-decorator'
import DeedCustomerData from '@/components/planning-cr/deed/DeedCustomerData.vue'   
import DeedCustomerSearch from '@/components/planning-cr/deed/DeedCustomerSearch.vue'   
import DeedDialogRemove from "@/components/planning-cr/deed/DeedDialogRemove.vue"  
import { EmailApi,PlanningTransferApi } from "@/api"
import { namespace } from 'vuex-class'

const Auth = namespace('authentication')

@Component({
    components: { 
        DeedCustomerSearch,
        DeedCustomerData,
        DeedDialogRemove
    }
})
export default class EmailDialog extends Vue { 
    @Prop(Function) public openNotification: any
    @Prop(Function) public FuncRefreshTableDataTransfer: any

    dialogSendEmail = false
    loading = false
    isShowEmailTemplate = false
    htmlTemplate = ""
    emailSubject = ""
    emailFrom = ""
    emailBcc = ""
    emailTo = ""
    emailCC = ""
    templateRequest = null as any
    
    @Auth.State('auth') auth!: any

    async OpenDialog (templateRequest: EmailApi.IGetEmailTemplateRequest) {
        console.log("EmailDialog->OpenDialog: ", templateRequest)
        this.loading = true
        this.dialogSendEmail = true
        this.templateRequest = templateRequest

        try {
            
            const response = await EmailApi.GetEmailTemplate(templateRequest)

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "openEmailDialog",
                page: "EmailDialog",
                json_data: JSON.stringify(response),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            if (response !== null) {
                this.emailSubject = response[0].emailSubject
                this.emailSubject = response[0].emailSubject
                this.htmlTemplate = response[0].emailTemplate
                this.emailFrom = response[0].emailFrom
                this.emailBcc = response[0].emailBcc
                this.emailTo = response[0].emailTo
                this.emailCC = response[0].emailCC
                this.loading = false
                return
            } 

            this.loading = false
            this.dialogSendEmail = false
            this.openNotification("ไม่พบข้อมูลสำหรับส่งอีเมล", "warning")
        } catch (error) {
            this.loading = false
            this.dialogSendEmail = false
            this.openNotification("ไม่สามารถโหลดข้อมูลสำหรับส่งอีเมลได้", "error")
        }
    }

    async BtnSendEmail () {
        console.log('-> BtnSendEmail')
        this.loading = true
        try { 
            const response = await EmailApi.SendEmail(this.templateRequest)
            if (response !== "OK") {
                this.openNotification("ส่งอีเมลไม่สำเร็จ กรุณาลองใหม่", "warning")
                this.dialogSendEmail = false
                this.loading = false
            }

            const logModel = {
                application_name: "Transfer_Planning",
                feature: "BtnSendEmail",
                page: "EmailDialog",
                json_data: JSON.stringify(response),
                created_by: this.auth.username,
                };

            PlanningTransferApi.addLog(logModel)

            const unitIdListsUpdated = this.templateRequest.map((m: any) => (m.unitId.toString()))
            await this.FuncRefreshTableDataTransfer(unitIdListsUpdated)
            this.openNotification("ส่งอีเมลสำเร็จ", "success")
            this.dialogSendEmail = false
            this.loading = false
        } catch (ex: any) {
            console.log(ex)
            this.dialogSendEmail = false
            this.loading = false
            this.openNotification("ไม่สามารถส่งอีเมลได้ กรุณาลองใหม่", "error")
        }
        
    }
    
    closeDialog () {
        this.dialogSendEmail = false
    }

}
